import React, { useMemo } from 'react'
import { InputAdornment, TextField } from '@material-ui/core'
import { SearchRounded } from '@material-ui/icons'

const SearchOfficesAndManagersInput = ({ onChange }) =>
  useMemo(() => {
    return (
      <TextField
        variant="outlined"
        placeholder="Search Offices"
        style={{ backgroundColor: 'white' }}
        fullWidth
        size="small"
        onChange={e => onChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRounded />
            </InputAdornment>
          ),
        }}
      />
    )
  }, [onChange])

export default SearchOfficesAndManagersInput
